import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const RequestMain = WithErrorBoundary(
  'Peritador',
  'Error en peritador',
  React.lazy(() => import('./RequestMain')),
)

const RequestCarGalery = WithErrorBoundary(
  'Galeria de peritador',
  'Error en galeria de peritador',
  React.lazy(() => import('./RequestCarGalery')),
)

const GenerarPdf = WithErrorBoundary(
  'Descarga de PDF',
  'Error en la descarga de PDF',
  React.lazy(() => import('../common/GenerarPdf')),
)

export default {
  path: '/peritador',
  name: 'Peritador',
  childRoutes: [
    { path: '', name: 'Request main', component: RequestMain, isIndex: true },
    { path: 'galery/:id', name: 'Galeria', component: RequestCarGalery},
    { path: 'generar-pdf/:id', name: 'Galeria', component: GenerarPdf},
  ],
}
